import React from 'react';

import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {Collaborator} from 'auth/PermissionConstants';
import {convertToCollaborationCreateOrUpdates} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {FullSource, Source, SourceSummary} from 'constants/SourceConstants';
import {
  OwnableSettingsWithCollaborationsModal,
  SuccessCallbackParams,
} from 'create-components/OwnableSettingsModal';
import SourceDAO, {CreateParams} from 'file-browser/SourceDAO';

import {UpdateOwnableParams} from './OwnableConstants';

function createSource(
  data: CreateParams,
  onCreateComplete: ((source?: SourceSummary & Pick<FullSource, 'permissions'>) => void) | undefined
): JQueryPromise<Source & Pick<FullSource, 'permissions'>> {
  const xhr = SourceDAO.create(data);
  if (onCreateComplete) {
    xhr.done(onCreateComplete);
  }
  return xhr;
}

export interface CreateSourceModalProps {
  initialCollaborators?: Array<Collaborator>;
  preferredOwnerId?: string;
  navigateOnSuccess?: boolean;
  onCreateComplete?: () => void;
  onRequestClose: () => void;
  successCallback?: (data: SuccessCallbackParams) => void;
}

export default function CreateSourceModal(props: CreateSourceModalProps): JSX.Element {
  const sharedProps = {
    onRequestClose: props.onRequestClose,
    navigateOnSuccess: props.navigateOnSuccess ?? true,
    successCallback: props.successCallback,
    ownableType: ModelTypeConstants.PROJECT,
    initialCollaborators: props.initialCollaborators,
    preferredOwnerId: props.preferredOwnerId,
    canManageCollaborators: true,
  };
  return (
    <OwnableSettingsWithCollaborationsModal
      {...sharedProps}
      supportReviewLifecycleSelection={BenchlingConfig.ENABLE_ENTRY_REVIEW_PROCESSES}
      allowAuditorToggling={true}
      doSubmit={(data: UpdateOwnableParams) =>
        createSource(
          {...data, collaborations: convertToCollaborationCreateOrUpdates(data.collaborations!)},
          props.onCreateComplete
        )
      }
      analyticsModule={ANALYTICS_MODULE.PROJECT_FOLDER}
      analyticsModalType="create_source"
    />
  );
}
